
































import Vue from 'vue'
import AccountBalanceDetailsChart from '@/components/elements/accountBalanceDetails/AccountBalanceDetailsChart.vue'
import { AccountBalanceDetailsElInterface, DataTab } from '@/config/interfaces'

export default Vue.extend({
  name: 'AccountBalanceDetailsEl',

  components: { AccountBalanceDetailsChart },

  data: () => ({
    currentActive: 0
  }),

  mounted () {
    this.$props.templateItemData.tabs.length > 1 && this.toggleActiveTab()
  },

  computed: {
    activeTab (): DataTab {
      return this.$props.templateItemData.tabs[this.currentActive]
    },
    dataTitles (): Array<string> {
      return this.$props.templateItemData.tabs.map((e: DataTab) => e.title)
    },
    resolveClasses (): string {
      if (this.$props.templateItemData.tabs.length > 1) {
        return 'w-100 d-flex justify-center cursor-pointer not--selected font--bolder unselectable'
      }
      return 'ml-3 font-weight-bold'
    }
  },

  methods: {
    toggleActiveTab (): void {
      const tab = this.$refs['title' + this.currentActive] as Array<HTMLDivElement>
      tab[0].classList.toggle('highlight')
    },
    updateData (idx: number): void {
      this.toggleActiveTab() // Remove highlight from current active tab (toggle)
      this.currentActive = idx
      this.toggleActiveTab()
      this.$emit('tabChange', idx) // Event is emitted for AccountBalanceDetailsLandline element
    }
  },

  props: {
    templateItemData: {
      type: Object as () => AccountBalanceDetailsElInterface,
      required: true
    }
  }
})
